export type Industry = {
    name: string;
    slug: string;
    termCode: string; // Add NAICS code for structured data
    keywords: string[];
};

const garment =
{
    name: 'May mặc', slug: 'May-mac', termCode: '315', keywords: [
        'May 1 kim',
        'May thường',
        'Vắt sổ',
        'Trần đè',
        'Máy Kansai',
        'May mặc',
        'Chăn ga gối đệm',
        'Công việc trước kéo sợi',
        'Công việc trước khi dệt',
        'Dệt hoàn thiện',
        'Dệt kim máy sợi dọc',
        'Dệt may',
        'Gia công dệt',
        'Gia công sợi hỗn hợp',
        'Kéo sợi tinh',
        'May khăn mặt',
        'May quần áo',
        'May quần áo nam',
        'Nhuộm chỉ',
        'Nhuộm vải, đan len',
        'Quần áo phụ nữ, trẻ em',
        'Quấn sợi',
        'Sản xuất áo sơ mi',
        'Sản xuất đồ lót',
        'Sản xuất ghế ngồi ô tô',
        'Sản xuất máy dệt kim tròn',
        'Sản xuất tất',
        'Sản xuất thảm dệt',
        'Sản xuất thảm đục lỗ',
        'Sản xuất thảm nhung nổi',
        'Sản xuất vải bạt'
    ]
}
export const industriesByJobType: { [key: string]: Industry[] } = {
    'thuc-tap-sinh-ky-nang': [
        {
            name: 'Xây dựng', slug: 'Xay-dung', termCode: '23', keywords: [
                'Bê tông',
                'Buộc thép',
                'Chống thấm',
                'Cốp pha công trình',
                'Dán tường',
                'Đổ bê tông áp lực',
                'Đổ nhựa đường',
                'Dựng giàn giáo',
                'Đường ống',
                'Đường ống điều hoà',
                'Đường ống nhà máy',
                'Đường ống nước',
                'Đường ống xây dựng',
                'Gia công đường ống',
                'Gia công khung thép',
                'Gia công khung thép trong xưởng',
                'Gia công sắt trong xưởng',
                'Gia công vật liệu đá',
                'Hàn khung thép trên cao',
                'Hoàn thiện nội thất',
                'Hoàn thiện sàn nhựa',
                'Hoàn thiện sàn thảm',
                'Hoàn thiện ván',
                'Hút nước ngầm công trình',
                'Khoan giếng máy dập',
                'Khoan giếng máy khoan',
                'Khung chắn toà nhà',
                'Lái máy ủi',
                'Lái máy xây dựng',
                'Lái máy xúc',
                'Lái máy xúc lật',
                'Lái xe lu',
                'Làm nền, móng',
                'Lắp bồn tắm',
                'Lắp đặt đường ống',
                'Lắp đặt lò nung-xây dựng',
                'Lắp đặt pin năng lượng',
                'Lắp điện lạnh, điều hòa',
                'Lắp ghép cốt thép',
                'Lát đá',
                'Lợp mái nhà',
                'Lợp ngói',
                'Mộc cốp pha',
                'Nội thất gỗ-xây dựng',
                'Ốp lát gạch',
                'Phá dỡ',
                'San lấp mặt bằng',
                'Sản xuất bê tông',
                'Sơn xây dựng',
                'Tấm kim loại kiến trúc',
                'Tấm kim loại ống gió',
                'Thi công dán tường',
                'Thi công lắp rèm',
                'Thi công móng thép',
                'Thợ mộc xây dựng',
                'Thợ xây',
                'Trát vữa',
                'Xây dựng tổng hợp'
            ]
        },
        {
            ...garment
        },
        {
            name: 'Cơ khí, kim loại', slug: 'Co-khi-kim-loai', termCode: '332710', keywords: [
                'Bản mạch in',
                'Bảo trì máy móc',
                'Chế tạo kim loại tấm',
                'Chế tạo máy',
                'Cơ khí',
                'Cuộn dây máy điện quay',
                'Dập khuôn kim loại',
                'Điện',
                'Điện tử',
                'Đóng tàu',
                'Đúc',
                'Đúc gang',
                'Đúc khuôn',
                'Đúc khuôn buồng lạnh',
                'Đúc khuôn buồng nóng',
                'Đúc kim loại màu',
                'Ép dập kim loại',
                'Gia công cơ khí',
                'Gia công ép đùn',
                'Gia công kim loại - Tekko',
                'Gia công tinh',
                'Hàn',
                'Hàn bán tự động',
                'Hàn kết cấu',
                'Hàn khí',
                'Hàn khung thép',
                'Hàn tàu',
                'Hàn thủ công',
                'Hàn tủ điện',
                'Hàn xì',
                'Hoàn thiện dụng cụ nung chảy',
                'Hoàn thiện khuôn',
                'Hoàn thiện sản phẩm ép đùn',
                'Kiểm tra máy móc',
                'Lắp đặt điều hoà',
                'Lắp đặt máy móc',
                'Lắp đặt tủ lạnh',
                'Lắp ráp điện',
                'Lắp ráp điện tử',
                'Lắp ráp linh kiện bán dẫn',
                'Lắp ráp máy biến áp',
                'Lắp ráp thiết bị điện khí',
                'Lắp ráp thiết bị điện quay',
                'Lắp ráp thiết bị điện tử',
                'Lắp thiết bị đóng, mở',
                'Lắp tủ điện, tủ điều khiển',
                'Mạ điện',
                'Mạ kẽm nhúng nóng',
                'Máy sản xuất tấm kim loại',
                'Rèn',
                'Rèn bằng búa',
                'Sơn',
                'Sơn cầu thép',
                'Sơn công trình xây dựng',
                'Sơn kim loại',
                'Sơn phun',
                'Sử dụng máy phay',
                'Sử dụng máy tiện số',
                'Sử dụng máy tiện thường',
                'Thi công điện',
                'Thi công kết cấu thép',
                'Thiết kế bảng mạch in',
                'Vận hành máy',
                'Vận hành máy CNC',
                'Vận hành máy ép',
                'Vận hành máy ép nhựa',
                'Vận hành robot',
                'Xử lý điện hóa nhôm'
            ]
        },
        {
            name: 'Nông nghiệp', slug: 'Nong-nghiep', termCode: '111', keywords: [
                'Chăn nuôi bò',
                'Chăn nuôi bò sữa',
                'Chăn nuôi gà',
                'Chăn nuôi lợn',
                'Nhặt trứng gà',
                'Nông nghiệp chăn nuôi',
                'Nông nghiệp trồng trọt',
                'Thu hoạch bắp cải',
                'Thu hoạch cà chua',
                'Thu hoạch dâu tây',
                'Thu hoạch hoa',
                'Thu hoạch hoa quả',
                'Thu hoạch nông sản',
                'Thu hoạch rau củ',
                'Trồng cây ăn quả',
                'Trồng nấm',
                'Trồng nấm công nghệ cao',
                'Trồng rau củ',
                'Trồng trọt nhà kính'
            ]
        },
        {
            name: 'Ngư nghiệp', slug: 'Ngu-nghiep', termCode: '11411', keywords: [
                'Câu cá ngừ cần và dây',
                'Câu mực',
                'Câu tôm, cua bằng lồng',
                'Đánh cá dây câu dài',
                'Đánh cá lưới kéo',
                'Đánh cá lưới rê',
                'Đánh cá lưới sào',
                'Đánh cá lưới thả',
                'Đặt lưới đánh cá',
                'Nuôi sò điệp'
            ]
        },
        {
            name: 'Thực phẩm', slug: 'Thuc-pham', termCode: '311', keywords: [
                'Bánh gạo',
                'Bánh kẹo',
                'Bánh ngọt',
                'Bếp viện',
                'Chế biến cá',
                'Chế biến đồ ăn sẵn',
                'Chế biến gia cầm',
                'Chế biến sushi',
                'Chế biến thịt bò, lợn',
                'Chế biến thuỷ sản sống',
                'Chiết xuất thuỷ sản',
                'Cơm hộp',
                'Cơm nắm',
                'Cửa hàng siêu thị',
                'Đậu hũ',
                'Đồ ăn kèm',
                'Đồ konbini',
                'Đóng gói bánh kẹo',
                'Đóng gói cafe',
                'Đóng gói gạo',
                'Đóng gói rau',
                'Đóng gói rau củ',
                'Đóng gói rong biển',
                'Đóng gói thanh cua',
                'Đóng hộp thực phẩm',
                'Gia công đồ ăn liền',
                'Giăm bông, xúc xích...',
                'Há cảo',
                'Làm bánh kẹo',
                'Mỳ tôm',
                'Salad',
                'Sản xuất bánh mì',
                'Sản xuất dưa muối',
                'Sản xuất mắm cá',
                'Sản xuất mỳ',
                'Siêu thị',
                'Tẩm ướp thuỷ sản',
                'Thái cá sashimi',
                'Thịt bò',
                'Thịt gà',
                'Thịt lợn',
                'Thức ăn cơ sở y tế',
                'Thực phẩm',
                'Thực phẩm sữa',
                'Thực phẩm trứng',
                'Thuỷ sản gia công chế biến',
                'Thuỷ sản khô',
                'Thuỷ sản lên men',
                'Thuỷ sản sấy khô',
                'Thuỷ sản ủ muối',
                'Thuỷ sản xông khói'
            ]
        },
        {
            name: 'Sản xuất, dịch vụ tổng hợp', slug: 'San-xuat-dich-vu-tong-hop', termCode: '3261', keywords: [
                'Bảo trì đường sắt',
                'Công việc cưa gỗ',
                'Đóng gói',
                'Đóng gói công nghiệp',
                'Đóng gói mỹ phẩm',
                'Đóng sách',
                'Đúc gốm bằng áp lực',
                'Đúc khuôn cao su',
                'Đục lỗ hộp in',
                'Đúc nhựa',
                'Đúc nhựa cán xếp chồng',
                'Đục nhựa ép phun',
                'Đúc nhựa nén',
                'Đúc nhựa thổi định hình',
                'Đúc nhựa thổi phồng',
                'Gia công đồ gia dụng',
                'Gia công ép đùn cao su',
                'Gia công sản phẩm gỗ',
                'Gỗ ép',
                'In gốm',
                'In offset',
                'In ống đồng',
                'In vỏ bánh kẹo',
                'Kiểm tra sản phẩm nhựa',
                'Nặn gốm bằng bánh xoay',
                'Nhiên liệu rắn từ rác',
                'Sản xuất hộp bìa cứng',
                'Sản xuất hộp in',
                'Sản xuất hộp nhãn dán',
                'Sản xuất linh kiện',
                'Sản xuất pin năng lượng',
                'Sản xuất vải lanh',
                'Thiết bị khí nén đường sắt',
                'Trộn và cán cao su',
                'Vật liệu composite nhiều lớp',
                'Vệ sinh phòng học'
            ]
        },
        {
            name: 'Ô tô', slug: 'O-to', termCode: '3363', keywords: [
                'Bảo dưỡng ô tô',
                'Kiểm tra linh kiện ô tô',
                'Lắp ráp linh kiện ô tô',
                'Linh kiện ô tô',
                'Sửa chữa ô tô'
            ]
        },
        {
            name: 'Hàng không', slug: 'Hang-khong', termCode: '4881', keywords: [
                'Hàng hóa hàng không',
                'Hỗ trợ mặt đất máy bay',
                'Dọn dẹp khoang hành khách'
            ]
        },
        {
            name: 'Vệ sinh tòa nhà', slug: 'Ve-sinh-toa-nha', termCode: '561720', keywords: [
                'Vệ sinh tòa nhà',
                'Buồng phòng khách sạn'
            ]
        },
        {
            name: 'Lưu trú, khách sạn', slug: 'Luu-tru-khach-san', termCode: '721110', keywords: [
                '(Khách sạn) Tiếp khách, quản lý vệ sinh',
                'Lễ tân khách sạn',
                'Quản lý khách sạn',
                'Hành lý khách sạn',
                'Lưu trú khách sạn'
            ]
        },
    ],
    'ky-nang-dac-dinh': [

        {
            name: 'Xây dựng', slug: 'Xay-dung', termCode: '23', keywords: [
                'Bê tông',
                'Buộc thép',
                'Chống thấm',
                'Cốp pha công trình',
                'Dán tường',
                'Đổ bê tông áp lực',
                'Đổ nhựa đường',
                'Dựng giàn giáo',
                'Đường ống',
                'Đường ống điều hoà',
                'Đường ống nhà máy',
                'Đường ống nước',
                'Đường ống xây dựng',
                'Gia công đường ống',
                'Gia công khung thép',
                'Gia công khung thép trong xưởng',
                'Gia công sắt trong xưởng',
                'Gia công vật liệu đá',
                'Hàn khung thép trên cao',
                'Hoàn thiện nội thất',
                'Hoàn thiện sàn nhựa',
                'Hoàn thiện sàn thảm',
                'Hoàn thiện ván',
                'Hút nước ngầm công trình',
                'Khoan giếng máy dập',
                'Khoan giếng máy khoan',
                'Khung chắn toà nhà',
                'Lái máy ủi',
                'Lái máy xây dựng',
                'Lái máy xúc',
                'Lái máy xúc lật',
                'Lái xe lu',
                'Làm nền, móng',
                'Lắp bồn tắm',
                'Lắp đặt đường ống',
                'Lắp đặt lò nung-xây dựng',
                'Lắp đặt pin năng lượng',
                'Lắp điện lạnh, điều hòa',
                'Lắp ghép cốt thép',
                'Lát đá',
                'Lợp mái nhà',
                'Lợp ngói',
                'Mộc cốp pha',
                'Nội thất gỗ-xây dựng',
                'Ốp lát gạch',
                'Phá dỡ',
                'San lấp mặt bằng',
                'Sản xuất bê tông',
                'Sơn xây dựng',
                'Tấm kim loại kiến trúc',
                'Tấm kim loại ống gió',
                'Thi công dán tường',
                'Thi công lắp rèm',
                'Thi công móng thép',
                'Thợ mộc xây dựng',
                'Thợ xây',
                'Trát vữa',
                'Xây dựng tổng hợp'
            ]
        },
        { ...garment },

        {
            name: 'Cơ khí, chế tạo máy', slug: 'Co-khi-che-tao-may', termCode: '332710', keywords: [
                'Bảo trì máy móc',
                'Chế tạo kim loại tấm',
                'Chế tạo máy',
                'Cơ khí',
                'Dập khuôn kim loại',
                'Đóng tàu',
                'Đúc',
                'Đúc gang',
                'Đúc khuôn',
                'Đúc khuôn buồng lạnh',
                'Đúc khuôn buồng nóng',
                'Đúc kim loại màu',
                'Ép dập kim loại',
                'Gia công cơ khí',
                'Gia công ép đùn',
                'Gia công kim loại - Tekko',
                'Gia công tinh',
                'Hàn',
                'Hàn bán tự động',
                'Hàn kết cấu',
                'Hàn khí',
                'Hàn khung thép',
                'Hàn tàu',
                'Hàn thủ công',
                'Hàn tủ điện',
                'Hàn xì',
                'Hoàn thiện dụng cụ nung chảy',
                'Hoàn thiện khuôn',
                'Hoàn thiện sản phẩm ép đùn',
                'Kiểm tra máy móc',
                'Lắp đặt điều hoà',
                'Lắp đặt máy móc',
                'Lắp đặt tủ lạnh',
                'Lắp ráp máy móc',
                'Máy sản xuất tấm kim loại',
                'Rèn',
                'Rèn bằng búa',
                'Sơn',
                'Sơn cầu thép',
                'Sơn công trình xây dựng',
                'Sơn kim loại',
                'Sơn phun',
                'Sử dụng máy phay',
                'Sử dụng máy tiện số',
                'Sử dụng máy tiện thường',
                'Thi công kết cấu thép',
                'Vận hành máy',
                'Vận hành máy CNC',
                'Vận hành máy ép',
                'Vận hành máy ép nhựa',
                'Vận hành robot',
                'Xử lý điện hóa nhôm'
            ]
        },
        {
            name: 'Điện, điện tử', slug: 'Dien-dien-tu', termCode: '33441', keywords: [
                'Bản mạch in',
                'Cuộn dây máy điện quay',
                'Điện',
                'Điện tử',
                'Lắp ráp điện',
                'Lắp ráp điện tử',
                'Lắp ráp linh kiện bán dẫn',
                'Lắp ráp máy biến áp',
                'Lắp ráp thiết bị điện khí',
                'Lắp ráp thiết bị điện quay',
                'Lắp ráp thiết bị điện tử',
                'Lắp thiết bị đóng, mở',
                'Lắp tủ điện, tủ điều khiển',
                'Sản xuất bảng mạch in',
                'Sửa chữa dụng cụ',
                'Sửa chữa tủ điện',
                'Thi công điện',
                'Thiết kế bảng mạch in'
            ]
        },
        {
            name: 'Nông nghiệp', slug: 'Nong-nghiep', termCode: '111', keywords: [
                'Chăn nuôi bò',
                'Chăn nuôi bò sữa',
                'Chăn nuôi gà',
                'Chăn nuôi lợn',
                'Nhặt trứng gà',
                'Thu hoạch nông sản',
                'Trồng cây ăn quả',
                'Trồng hoa',
                'Trồng nấm',
                'Trồng rau củ quả trong nhà kính',
                'Trồng rau củ quả ngoài trời'
            ]
        },
        {
            name: 'Ngư nghiệp', slug: 'Ngu-nghiep', termCode: '11411', keywords: [
                'Nuôi trồng thủy sản',
                'Đánh bắt cá'
            ]
        },
        {
            name: 'Nhà hàng', slug: 'Nha-hang', termCode: '722511', keywords: [
                'Chạy bàn',
                'Mua hàng',
                'Nấu bếp',
                'Nhà hàng',
                'Phụ bếp',
                'Quản lý',
                'Rửa bát',
                'Thu ngân'
            ]
        },
        {
            name: 'Thực phẩm', slug: 'Thuc-pham', termCode: '311', keywords: [
                'Bánh gạo',
                'Bánh kẹo',
                'Bánh ngọt',
                'Bếp viện',
                'Chế biến cá',
                'Chế biến đồ ăn sẵn',
                'Chế biến gia cầm',
                'Chế biến sushi',
                'Chế biến thịt bò, lợn',
                'Chế biến thuỷ sản sống',
                'Chiết xuất thuỷ sản',
                'Cơm hộp',
                'Cơm nắm',
                'Cửa hàng siêu thị',
                'Đậu hũ',
                'Đồ ăn kèm',
                'Đồ konbini',
                'Đóng gói bánh kẹo',
                'Đóng gói cafe',
                'Đóng gói gạo',
                'Đóng gói rau',
                'Đóng gói rau củ',
                'Đóng gói rong biển',
                'Đóng gói thanh cua',
                'Đóng hộp thực phẩm',
                'Gia công đồ ăn liền',
                'Giăm bông, xúc xích...',
                'Há cảo',
                'Làm bánh kẹo',
                'Mỳ tôm',
                'Salad',
                'Sản xuất bánh mì',
                'Sản xuất dưa muối',
                'Sản xuất mắm cá',
                'Sản xuất mỳ',
                'Siêu thị',
                'Tẩm ướp thuỷ sản',
                'Thái cá sashimi',
                'Thịt bò',
                'Thịt gà',
                'Thịt lợn',
                'Thức ăn cơ sở y tế',
                'Thực phẩm',
                'Thực phẩm sữa',
                'Thực phẩm trứng',
                'Thuỷ sản gia công chế biến',
                'Thuỷ sản khô',
                'Thuỷ sản lên men',
                'Thuỷ sản sấy khô',
                'Thuỷ sản ủ muối',
                'Thuỷ sản xông khói'
            ]
        },
        {
            name: 'Sản xuất, dịch vụ tổng hợp', slug: 'San-xuat-dich-vu-tong-hop', termCode: '3261', keywords: [
                'Bảo dưỡng ô tô',
                'Công việc cưa gỗ',
                'Đóng gói',
                'Đóng gói công nghiệp',
                'Đóng gói mỹ phẩm',
                'Đóng sách',
                'Đúc gốm bằng áp lực',
                'Đúc khuôn cao su',
                'Đục lỗ hộp in',
                'Đúc nhựa',
                'Đúc nhựa cán xếp chồng',
                'Đục nhựa ép phun',
                'Đúc nhựa nén',
                'Đúc nhựa thổi định hình',
                'Đúc nhựa thổi phồng',
                'Gia công đồ gia dụng',
                'Gia công ép đùn cao su',
                'Gia công sản phẩm gỗ',
                'Gỗ ép',
                'In gốm',
                'In offset',
                'In ống đồng',
                'In vỏ bánh kẹo',
                'Kiểm tra sản phẩm nhựa',
                'Nặn gốm bằng bánh xoay',
                'Nhiên liệu rắn từ rác',
                'Sản xuất hộp bìa cứng',
                'Sản xuất hộp in',
                'Sản xuất hộp nhãn dán',
                'Sản xuất linh kiện',
                'Sản xuất pin năng lượng',
                'Sản xuất vải lanh',
                'Sửa chữa ô tô',
                'Thiết bị khí nén đường sắt',
                'Trộn và cán cao su',
                'Vật liệu composite nhiều lớp'
            ]
        },
        {
            name: 'Chế tạo Vật liệu', slug: 'Che-tao-vat-lieu', termCode: '33281', keywords: [
                'Xử lý nhiệt bề mặt',
                'Xử lý nhiệt một phần',
                'Xử lý nhiệt tổng thể'
            ]
        },
        {
            name: 'Ô tô', slug: 'O-to', termCode: '3363', keywords: [
                'Bảo dưỡng ô tô',
                'Kiểm tra linh kiện ô tô',
                'Lắp ráp linh kiện ô tô',
                'Linh kiện ô tô',
                'Sửa chữa ô tô'
            ]
        },
        {
            name: 'Hàng không', slug: 'Hang-khong', termCode: '4881', keywords: [
                'Hàng hóa hàng không',
                'Hỗ trợ mặt đất máy bay',
                'Dọn dẹp khoang hành khách'
            ]
        },
        {
            name: 'Vận tải', slug: 'Van-tai', termCode: '484', keywords: [
                'Hậu cần vận tải',
                'Lái xe',
                'Lái xe buýt',
                'Lái xe tải',
                'Phụ xe',
                'Quản lý kho vận tải',
                'Thực tập lái xe'
            ]
        },
        {
            name: 'Vệ sinh tòa nhà', slug: 'Ve-sinh-toa-nha', termCode: '561720', keywords: [
                'Buồng phòng khách sạn',
                'Vệ sinh tòa nhà'
            ]
        },
        {
            name: 'Lưu trú, khách sạn', slug: 'Luu-tru-khach-san', termCode: '721110', keywords: [
                '(Khách sạn) Tiếp khách, quản lý vệ sinh',
                'Hành lý khách sạn',
                'Lễ tân khách sạn',
                'Lưu trú khách sạn',
                'Quản lý khách sạn'
            ]
        },
        {
            name: 'Điều dưỡng', slug: 'Dieu-duong', termCode: '623110', keywords: [
                'Điều dưỡng',
                'Chăm sóc người già',
                'Hộ lý'
            ]
        }
    ],
    'ky-su-tri-thuc': [
        {
            name: "Xây dựng", slug: "Xay-dung", termCode: '23', keywords: [
                "Cầu đường",
                "Công nghệ xây dựng của nước ngoài",
                "Công nhân kết cấu xây dựng",
                "Công nhân xây dựng (trừ khung công trình)",
                "Công nhân xây dựng mỏ tổng hợp",
                "Công nhân xây dựng nước ngoài",
                "Đường ống",
                "Giám sát thi công",
                "Hoàn thiện nội thất",
                "Khảo sát",
                "Kiến trúc sư",
                "Kỹ thuật Khảo sát",
                "Kỹ thuật Kiến trúc",
                "Kỹ thuật Kiến trúc, Xây dựng, Khảo sát",
                "Kỹ thuật Xây dựng",
                "Nội thất gỗ",
                "Quản lý, giám sát thi công công trình",
                "Trắc địa, khảo sát",
                "Xây dựng dân dụng"
            ]
        },
        { ...garment },
        {
            name: "Cơ khí, máy móc", slug: "Co-khi-may-moc", termCode: '332710', keywords: [
                "Bảo trì hệ thống điện",
                "Bảo trì máy móc",
                "Chế tạo máy",
                "Cơ khí",
                "Công nghệ cơ khí",
                "Công nhân đóng tàu nước ngoài",
                "Công nhân sản xuất, gia công kim loại",
                "Điện cơ khí hỗ trợ chuyển nhà",
                "Điện nội thất",
                "Điện, kỹ thuật điện",
                "Gia công cơ khí",
                "Kiểm tra máy móc",
                "Lắp đặt điều hoà",
                "Lắp đặt máy móc",
                "Lắp đặt tủ lạnh",
                "Lắp ráp máy móc",
                "Phân tích CAE",
                "Quản lý sản xuất máy",
                "Thiết kế Auto CAD",
                "Thiết kế cơ khí",
                "Thiết kế điện",
                "Tự động hoá",
                "Vận hành máy",
                "Vận hành máy CNC",
                "Vận hành máy ép",
                "Vận hành máy ép nhựa",
                "Vận hành robot",
                "Viễn thông"
            ]
        },
        {
            name: "Nông lâm ngư nghiệp", slug: "Nong-lam-ngu-nghiep", termCode: '11', keywords: [
                "Chăn nuôi",
                "Công nghệ nông, lâm, ngư nghiệp",
                "Công nhân chăn nuôi đặc khu",
                "Công nhân Nông, Lâm, Ngư nghiệp",
                "Công nhân trồng trọt đặc khu"
            ]
        },
        {
            name: "Thực phẩm", slug: "Thuc-pham", termCode: '311', keywords: [
                "Thực phẩm",
                "Đồ uống"
            ]
        },
        {
            name: "Sản xuất, chế tạo, công nghệ", slug: "San-xuat-cong-nghe", termCode: '31-33', keywords: [
                "Công nghệ môi trường",
                "Công nghệ sản xuất",
                "Công nhân sản xuất, gia công sản phẩm (trừ kim loại, máy móc)",
                "Gia công đồ xa xỉ",
                "Hoá học làm xưởng",
                "In ấn",
                "IT làm xưởng",
                "Khoan khảo sát dầu mỏ, năng lượng",
                "Kinh tế làm xưởng",
                "Lao động nước ngoài lĩnh vực sản xuất",
                "May mặc",
                "Môi trường làm xưởng",
                "Nhân viên sân bay",
                "Quản lý sản xuất tổng hợp",
                "Rác thải, phế liệu, tái chế",
                "Sản xuất sản phẩm",
                "Sản xuất sản phẩm cho nước ngoài",
                "Thiết kế thời trang"
            ]
        },
        {
            name: "Công nghệ ô tô", slug: "Cong-nghe-o-to", termCode: '81111', keywords: [
                "Ô tô",
                "Thiết kế ô tô"
            ]
        },
        {
            name: "Vận chuyển hàng hóa", slug: "Van-chuyen-hang-hoa", termCode: '488510', keywords: [
                "Đại lý thủ tục hàng hải",
                "Quản lý dọn dẹp",
                "Quản lý đóng gói",
                "Quản lý vận chuyển",
                "Quản lý vận chuyển, dọn dẹp, đóng gói"
            ]
        },
        {
            name: "Khách sạn, lưu trú", slug: "Khach-san-luu-tru", termCode: '721110', keywords: [
                "Dịch vụ khách sạn",
                "Khu nghỉ dưỡng",
                "Lễ tân khách sạn"
            ]
        },
        {
            name: "Y tế, điều dưỡng", slug: "Y-te-dieu-duong", termCode: '62', keywords: [
                "Bác sĩ",
                "Bác sĩ chỉnh thị lực",
                "Chuyên viên phục hình",
                "Điều dưỡng có chứng chỉ",
                "Điều dưỡng dự bị học EPA",
                "Điều dưỡng, hộ lý EPA",
                "Điều dưỡng, hộ lý EPA dự bị",
                "Dược sĩ",
                "Kỹ thuật viên X quang",
                "Nha sĩ",
                "Nhà trị liệu nghề nghiệp",
                "Nữ hộ sinh",
                "Trợ lý y tá",
                "Vật lý trị liệu",
                "Vệ sinh răng miệng",
                "Y tá",
                "Y tá EPA",
                "Y tá EPA dự bị",
                "Y tá sức khoẻ cộng đồng",
                "Y tế lâm sàng"
            ]
        },
        {
            name: "Kinh doanh, kinh tế", slug: "Kinh-doanh-kinh-te", termCode: '541611', keywords: [
                "Bán hàng miễn thuế",
                "Dịch vụ bán hàng",
                "Dịch vụ khách hàng tổng hợp",
                "Điều hành",
                "Hoạt động khởi nghiệp",
                "Kinh doanh kế toán",
                "Kinh tế",
                "Nghiên cứu thị trường, marketing",
                "Nhân viên dịch vụ khác (không phân loại nơi khác)",
                "Quản lý",
                "Quản lý kế hoạch quảng cáo, truyền thông",
                "Thương mại nước ngoài",
                "Tiếp thị (sales) doanh nghiệp"
            ]
        },
        {
            name: "Tài chính, kế toán, bảo hiểm", slug: "Tai-chinh-ke-toan-bao-hiem", termCode: '52', keywords: [
                "Kế toán công chứng",
                "Kế toán công chứng nước ngoài",
                "Kế toán thuế",
                "Tài chính, bảo hiểm",
                "Tư vấn bảo hiểm xã hội"
            ]
        },
        {
            name: "Báo chí, truyền thông, marketing", slug: "Bao-chi-truyen-thong-marketing", termCode: '51', keywords: [
                "Báo chí",
                "Biên tập",
                "Digital Marketing",
                "Marketing",
                "Nhà báo",
                "Thiết kế Marketing",
                "Truyền thông",
                "Viết quảng cáo"
            ]
        },
        {
            name: "Công nghệ thông tin", slug: "It", termCode: '541511', keywords: [
                "Công nghệ thông tin",
                "IT",
                "IT Support",
                "Lập trình",
                "Phần mềm",
                "Blockchain",
                "BrSE (Bridge System Engineer)",
                "Business Analyst (BA)",
                "COO (Chief Operation Officer)",
                "CTO (Chief Technology Officer)",
                "ITM (Information Technical Manager)",
                "Lập trình nhúng",
                "Lập trình viên",
                "PM (Product Manager)",
                "PO (Product Owner)",
                "Tester",
                "Thiết kế UI, UX",
                "Trí tuệ nhân tạo",
                "Vận hành web thương mại điện tử"
            ]
        },
        {
            name: "Nghiên cứu, phân tích", slug: "Nghien-cuu-phan-tich", termCode: '5417', keywords: [
                "Khảo sát đất đai, nhà ở",
                "Nghiên cứu",
                "Nghiên cứu thị trường"
            ]
        },
        {
            name: "Giáo dục, đào tạo", slug: "Giao-duc-dao-tao", termCode: '61', keywords: [
                "Giảng dạy có chứng chỉ",
                "Giảng dạy đại học",
                "Giảng dạy ngoài cơ sở giáo dục",
                "Giảng dạy ngôn ngữ tại Tiểu học, THCS, PTTH",
                "Giảng dạy trường dạy nghề (Senmon)",
                "Giảng dạy trường học các loại",
                "Giảng dạy trường quốc tế",
                "Hướng dẫn nghiên cứu",
                "Hướng dẫn thể thao"
            ]
        },
        {
            name: "Hành chính, văn phòng", slug: "Hanh-chinh-van-phong", termCode: '561110', keywords: [
                "Biên dịch, phiên dịch",
                "Nhân viên văn phòng"
            ]
        },
        {
            name: "Pháp lý", slug: "Phap-ly", termCode: '5411', keywords: [
                "Dịch vụ pháp lý",
                "Chuyên viên pháp lý hành chính",
                "Lập văn bản tư pháp",
                "Luật sư",
                "Luật sư sở hữu trí tuệ",
                "Luật sư luật nước ngoài",
                "Luật sư nước ngoài"
            ]
        },
        {
            name: "Nghệ thuật, nghệ sĩ", slug: "Nghe-thuat", termCode: '711510', keywords: [
                "Mỹ thuật gia",
                "Nhiếp ảnh gia",
                "Nhà văn",
                "Nhạc sĩ",
                "Nghệ sĩ sân khấu"
            ]
        },
        {
            name: "Thể dục thể thao", slug: "The-thao", termCode: '71121', keywords: [
                "Vận động viên chuyên nghiệp",
                "Vận động viên nghiệp dư"
            ]
        },
        {
            name: "Nghề có kỹ năng chuyên nghiệp", slug: "Nghe-chuyen-nghiep", termCode: '812990', keywords: [
                "Công chức",
                "Giúp việc gia đình đặc khu",
                "Huấn luyện động vật",
                "Nấu nướng",
                "Người pha chế rượu",
                "Người quản gia",
                "Nhà ngoại giao",
                "Nhân viên tôn giáo",
                "Phi công"
            ]
        },
        {
            name: "Việc làm bán chuyên nghiệp", slug: "Viec-lam-ban-chuyen-nghiep", termCode: '611630', keywords: [
                "Công việc mùa hè",
                "Lao động kỳ nghỉ",
                "Sinh viên thực tập",
                "Trao đổi văn hóa quốc tế"
            ]
        }
    ]
};

export const industryGroups = {
    'Công xưởng': ['Chế biến thực phẩm', 'Cơ khí', 'Điện tử', 'Dệt may', 'May mặc', 'Cơ khí, kim loại', 'Cơ khí, chế tạo máy', 'Điện, điện tử'],
    'Ngoài trời': ['Xây dựng', 'Nông nghiệp', 'Ngư nghiệp'],
    'Dịch vụ & Chăm sóc con người': ['Điều dưỡng', 'Nhà hàng', 'Vận tải', 'Lưu trú, khách sạn', 'Vệ sinh tòa nhà', 'Hàng không'],
};

export const allIndustries = Object.values(industriesByJobType).flat().filter((v, i, a) => a.findIndex(t => (t.name === v.name)) === i);

export const specificJobOptions = [
    { name: 'Mạ', slug: 'ma' },
    { name: 'Nhựa', slug: 'nhua' },
    { name: 'Dập kim loại', slug: 'dap-kim-loai' },
    { name: 'Tấm thép nhà xưởng', slug: 'tam-thep-nha-xuong' },
    { name: 'Gia công tinh', slug: 'gia-cong-tinh' },
    { name: 'Hàn xì', slug: 'han-xi' },
    { name: 'Đóng gói công nghiệp', slug: 'dong-goi-cong-nghiep' },
    { name: 'Đóng gói linh kiện', slug: 'dong-goi-linh-kien' },
    { name: 'Linh kiện ô tô', slug: 'linh-kien-o-to' },
    { name: 'Bếp viện', slug: 'bep-vien' },
    { name: 'Hoàn thiện nội thất', slug: 'hoan-thien-noi-that' },
    { name: 'Xây trát', slug: 'xay-trat' },
    { name: 'Giàn giáo', slug: 'gian-giao' },
    { name: 'Cốp pha', slug: 'cop-pha' },
    { name: 'Buộc thép', slug: 'buoc-thep' },
    { name: 'Tấm thép xây dựng', slug: 'tam-thep-xay-dung' },
];

export const engineerJobOptions = [
    'Kinh tế làm xưởng', 'Hoá học làm xưởng', 'Sinh học làm xưởng', 'Quản lý sản xuất thực phẩm', 'Công nghệ thực phẩm', 'Thực phẩm', 'Đóng gói rau', 'Thiết kế cơ khí', 'Thiết kế Auto CAD', 'Thiết kế điện', 'Điện nội thất', 'Điện cơ khí hỗ trợ chuyển nhà', 'Bảo trì hệ thống điện', 'Điện, kỹ thuật điện', 'Viễn thông', 'Quản lý sản xuất máy', 'Chế tạo máy', 'Lắp đặt tủ lạnh', 'Lắp đặt điều hoà', 'Lắp đặt máy móc', 'Lắp ráp máy móc', 'Kiểm tra máy móc', 'Bảo trì máy móc', 'Vận hành máy', 'Vận hành máy CNC', 'Vận hành máy ép', 'Vận hành máy ép nhựa', 'Tự động hoá', 'Vận hành robot', 'Cơ khí', 'Gia công cơ khí', 'Công nghệ cơ khí', 'Thiết kế ô tô', 'Ô tô', 'Nhân viên sân bay', 'Quản lý đóng gói', 'Quản lý dọn dẹp', 'Quản lý vận chuyển, dọn dẹp, đóng gói', 'Quản lý vận chuyển', 'Đại lý thủ tục hàng hải', 'Trắc địa, khảo sát', 'Khảo sát', 'Kỹ thuật Khảo sát', 'Kỹ thuật Kiến trúc, Xây dựng, Khảo sát', 'Kỹ thuật Kiến trúc', 'Kiến trúc sư', 'Quản lý, giám sát thi công công trình', 'Giám sát thi công', 'Cầu đường', 'Kỹ thuật Xây dựng', 'Xây dựng dân dụng', 'Công nhân kết cấu xây dựng', 'Công nhân xây dựng (trừ khung công trình)', 'Công nghệ xây dựng của nước ngoài', 'Công nhân xây dựng nước ngoài', 'Công nhân xây dựng mỏ tổng hợp', 'Nội thất gỗ', 'Hoàn thiện nội thất', 'Đường ống', 'Lễ tân khách sạn', 'Khu nghỉ dưỡng', 'Dịch vụ khách sạn', 'Kinh tế', 'Tiếp thị (sales) doanh nghiệp', 'Dịch vụ bán hàng', 'Dịch vụ khách hàng tổng hợp', 'Bán hàng miễn thuế', 'Marketing', 'Digital Marketing', 'Thiết kế Marketing', 'Truyền thông', 'Business Analyst (BA)', 'Product Manager (PM)', 'Product Owner (PO)', 'Thiết kế UI, UX', 'Thiết kế', 'Lập trình viên', 'BrSE (Bridge System Engineer)', 'Tester', 'CTO (Chief Technology Officer)', 'Vận hành web thương mại điện tử'
].map(name => ({ name, slug: name.toLowerCase().replace(/\s+/g, '-') }));
